(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('FreightPaymentImportDialogController',FreightPaymentImportDialogController);

    FreightPaymentImportDialogController.$inject = ['$scope','$stateParams','$q','$uibModal','FreightPaymentCustomService','ToastrService','MiscService','DateUtils'];

    function FreightPaymentImportDialogController($scope, $stateParams, $q, $uibModal, FreightPaymentCustomService, ToastrService, MiscService, DateUtils) {
        var vm = this;

        vm.separators = ['Point', 'Comma'];
        vm.separator = vm.separators[0];
        vm.dateFormats = [
            {format: 'yyyy-mm-dd', example: '2019-04-23'},
            {format: 'mm-dd-yyyy', example: '04-23-2019'},
            {format: 'dd-mm-yyyy', example: '23-04-2019'}
        ];
        vm.dateFormat = vm.dateFormats[1];
        vm.fps = [];
        vm.possibleDuplicates = [];
        vm.afterSave = [];

        vm.checkDuplicates = checkDuplicates;
        vm.save = save;
        vm.updateFreightPayment = updateFreightPayment;

        vm.activateSeparator = activateSeparator;

        function activateSeparator(option) {
            vm.separator = option;
        }

        function checkDuplicates() {
            vm.fps = [];
            vm.possibleDuplicates = [];
            vm.afterSave = [];
            vm.hot.data.forEach(function(element) {
                if(Object.keys(element).length > 0) {
                    buildFreightPayment(element);
                }
            });
            if(vm.fps.length > 0) {
                vm.checkBlNumbers = [];
                vm.fps.forEach(function(value, key) {
                    vm.checkBlNumbers.push(value.blNumber);
                });
                FreightPaymentCustomService.returnFreightPaymentsByBlNumbers(vm.checkBlNumbers).then(function(data) {
                    vm.possibleDuplicates = data.data;
                    if(vm.possibleDuplicates.length === 0) {
                        ToastrService.info("No possible duplicates found");
                    }
                }, function(error) {
                    ToastrService.error("Something went wrong with checking the Bl Numbers", "Error");
                });
            }
        }

        function save() {
            vm.fps = [];
            vm.possibleDuplicates = [];
            vm.afterSave = [];
            vm.hot.data.forEach(function(element) {
                if(Object.keys(element).length > 0) {
                    buildFreightPayment(element);
                }
            });
            vm.isSaving = true;
            FreightPaymentCustomService.saveImportFreightPayments(vm.fps).then(function(data) {
                ToastrService.success("Successfully imported Freight Payments", "Success!");
                vm.isSaving = false;
                vm.afterSave = data.data;
                vm.hot.data = [];
                vm.fps = [];
            }, function(error) {
                ToastrService.error("Failed to import Freight Payments", "Error");
                vm.isSaving = false;
            });
        }

        function buildFreightPayment(data) {
            var invoiceAmount = resolveInvoiceAmount(data.invoiceAmount);
            var invoiceCurrency = resolveCurrency(data.invoiceCurrency);
            var invoiceAmountDisplay = buildInvoiceAmountDisplay(invoiceCurrency, invoiceAmount);
            var bookingNumber = null;
            var freightPayment = {
                id: null,
                createdOn: new Date(),
                createdBy: 'admin',
                modifiedOn: new Date(),
                modifiedBy: 'admin',
                blNumber: data.blNumber,
                shipmentBookingNumber: bookingNumber,
                carrier: data.carrier,
                paymentDate: resolvePaymentDate(data.paymentDate, vm.dateFormat.format),
                invoiceAmount: invoiceAmount,
                invoiceCurrency: invoiceCurrency,
                invoiceAmountDisplay: invoiceAmountDisplay,
                comment: data.comment
            };
            vm.fps.push(freightPayment);
        }

        vm.hot = {
            settings: {colHeaders: true, contextMenu: ['row_above', 'row_below','remove_row']},
            rowHeaders: true,
            minSpareRows: 1,
            data: []
        };

        function resolvePaymentDate(paymentDate, format) {
            if(paymentDate) {
                return MiscService.resolveDateStringByFormat(paymentDate, format);
            } else {
                return null;
            }
        }

        function resolveInvoiceAmount(value) {
            if(value) {
                return periodsOrCommas(value);
            } else {
                return null;
            }
        }

        function resolveCurrency(value) {
            if(value) {
                return value.toUpperCase() === "EUR" ? "EUR" : "USD";
            } else {
                return null;
            }
        }

        function buildInvoiceAmountDisplay(currency, value) {
            if(value) {
                return currency + " " + value;
            } else {
                return null;
            }
        }

        function periodsOrCommas(value) {
            if(vm.separator === "Point") {
                return mathRoundIgnoreCommas(value);
            } else {
                return mathRoundConvertCommasToDecimal(value);
            }
        }

        function mathRoundIgnoreCommas(value) {
            if(value) {
                var numberNoCommas = value.replace(/,/g, '');
                return Math.round(numberNoCommas * 100) / 100;
            } else {
                return null;
            }
        }

        function mathRoundConvertCommasToDecimal(value) {
            if(value) {
                var numberConvertCommas = value.replace(/,/g, '.');
                return Math.round(numberConvertCommas * 1000) / 1000;
            } else {
                return null;
            }
        }

        function updateFreightPayment(index) {
            var toUpdate = angular.copy(vm.afterSave[index]);
            resolvePaymentDateOnUpdate(toUpdate)
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/freight-payment/freight-payment-dialog.html',
                controller: 'FreightPaymentDialogController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    entity: function() {
                        return toUpdate;
                    },
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('freight-payment');
                        $translatePartialLoader.addPart('currencyType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function(result) {
                vm.afterSave[index] = result;
            });
        }

        function resolvePaymentDateOnUpdate(fp) {
            if(fp.paymentDate !== null && fp.paymentDate !== undefined) {
                fp.paymentDate = DateUtils.convertLocalDateFromServer(fp.paymentDate);
            }
        }

        vm.createTab = function(data) {
            $scope.$emit('handleEmit', data);
        };

        vm.getOrDash = function(val) {
            return (val && val !== null) ? val : '-';
        };
    }
})();
